import React, {Component} from "react";
import Authentication from "../../authentication/Authentication";
import "./UpgradeService.css"
import Api from "../../api/Api";
import {toast} from "react-toastify";


export default class UpgradeService extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checked: "",
            showUpgradeButton: false,
            showLoading: false,
            showUpgradeMessage: false
        };

        this.authentication = new Authentication();
    };


    handleUpgrade = () => {
        this.setState({
            showLoading: false,
            showUpgradeMessage: true,
            checked: ""
        })

    }


    handleCheckboxClick = (e, release) => {
        if (release === this.state.checked) {
            this.setState({
                checked: ""
            })
        } else {
            this.setState({
                checked: release
            })
        }
    }

    upgradeService = (release) => {
        const api = new Api()

        this.setState({
            showLoading: true
        })

        if (this.authentication.isAdmin()) {
            api.pisaasUpgradeService(this.handleUpgrade, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.pisaasInstance.domain, release.docker_tag, this.props.pisaasInstance.package_id, this.props.pisaasInstance.pisaas_instance_id, this.props.pisaasInstance.region);
        }
    }

    render() {
        return (
            <>
                <div>
                    <h2 className={"config-header"} data-testid="config.header.upgrade">Upgrade</h2>
                    <ul>
                        <li>Select the version you wish to upgrade to then click the upgrade button</li>
                        <li>The upgrade will happen over approximately 1.5 hours</li>
                        <li>If the upgrade fails it will rollback to the original version</li>
                    </ul>
                    <div>
                        <p className={"field-name"}  data-testid="config.upgrade.availableReleases">Available Releases: </p>
                            {this.props.releases.map((release, index) => {
                                return (
                                    <div className={"upgrade-list"} data-testid="config.upgrade.availableReleases.list">
                                        <div className={"release-info-block"} key={index}>
                                            <div className={"release-info-list"} data-testid="config.upgrade.list.info">
                                                <p data-testid="config.upgrade.list.version">Version: {release.docker_tag}</p>
                                                <p data-testid="config.upgrade.list.description">Description: {release.description}</p>
                                                <a data-testid="config.upgrade.list.releaseNotes" className={"release-link"} href={release.release_notes_url}>Release Notes</a>
                                            </div>
                                        </div>
                                        <input onChange={(e) => this.handleCheckboxClick(e, release)} checked={this.state.checked === release} className={"release-checkbox"} type={"checkbox"}  data-testid="config.upgrade.checkbox"/>
                                    </div>

                                )
                            })}
                        {this.state.showLoading ?  <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading"/> : this.state.checked ? <button onClick={() => this.upgradeService(this.state.checked)} className={"upgrade-button"}  data-testid="config.upgrade.button">UPGRADE</button> : <></>}
                        {this.state.showUpgradeMessage ? <p data-testid="config.upgrade.message">Thanks for upgrading. This can take up to 1.5 hours.</p> : <></>}
                    </div>
                </div>
            </>
        )
    }
}



